import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslation from "./TraLanguage/enTranslation.json";
import arTranslation from "./TraLanguage/arTranslation.json";

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: enTranslation },
            ar: { translation: arTranslation },
        },
        fallbackLng: "en",
        debug: false,
        detection: {
            order: ["localStorage", "cookie", "navigator"],
            caches: ["localStorage", "cookie"],
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    });

if (i18n.language === "ar") {
    document.documentElement.dir = "rtl";
} else {
    document.documentElement.dir = "ltr";
}

export default i18n;
